export const GET_LIVE_OPS = 'GET_LIVE_OPS';
export const SET_LIVE_OPS = 'SET_LIVE_OPS';
export const TOGGLE_AUTOREFRESH = 'TOGGLE_AUTOREFRESH';
